module.exports = __webpack_public_path__ + "9c4794b091302442b6a0c5452c4d6a79.ttf";